export const connectedPickerPlacements = {
  bottomLeft: {
    points: ["tl", "bl"],
    offset: [0, -1],
    overflow: {
      adjustX: 1,
      adjustY: 1,
    },
  },
  bottomRight: {
    points: ["tr", "br"],
    offset: [0, -1],
    overflow: {
      adjustX: 1,
      adjustY: 1,
    },
  },
  topLeft: {
    points: ["bl", "tl"],
    offset: [0, 1],
    overflow: {
      adjustX: 0,
      adjustY: 1,
    },
  },
  topRight: {
    points: ["br", "tr"],
    offset: [0, 1],
    overflow: {
      adjustX: 0,
      adjustY: 1,
    },
  },
};
